<template>
  <div>
    <v-container class="front">
      <v-img
        class="d-inline-block"
        height="50"
        width="200px"
        position="left"
        contain
        src="@/assets/logo-cromatic.png"
      ></v-img>
      <div class="d-inline-block">
        <h1>{{userData.orgName}}</h1>
      </div>
      <br />
      <br />
      <ParticipantData :participant="participant" />
      <ReportResult />
      <ResultTable :participant="participant" />
    </v-container>
    <v-fab-transition v-if="showPrintBTN">
      <v-btn @click="print" color="indigo" fab large dark bottom right fixed>
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import axios from "axios";

import ParticipantData from "@/components/result/ParticipantData";
import ReportResult from "@/components/result/ReportResult";
import ResultTable from "@/components/result/ResultTable";

export default {
  components: {
    ParticipantData,
    ReportResult,
    ResultTable
  },
  data() {
    return {
      participant: {},
      host: process.env.VUE_APP_HOST,
      showPrintBTN: true,
      userData: {}
    };
  },
  methods: {
    print() {
      this.showPrintBTN = false;
      setTimeout(() => {
        if (window.print()) {
          this.showPrintBTN = true;
        } else {
          this.showPrintBTN = true;
        }
      }, 100);
    },
    getUserData() {
      axios
        .get(
          this.host +
            `/users/read.php?query=user&idUser=${this.$route.params.clientId}`
        )
        .then(response => {
          this.userData = response.data.userData;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getParticipant() {
      var vm = this;
      let data = {
        idUser: this.$route.params.clientId,
        idParticipant: this.$route.params.participantId,
        personalData: true
      };

      axios
        .post(this.host + "/participants/read.php", this.createFormData(data))
        .then(response => {
          vm.participant = response.data.data[0];
        })
        .catch(error => {
          this.snackbar = true;
          this.message = "error";
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getParticipant();
    this.getUserData();
  }
};
</script>